var app = app || {};

app.BVDCalc = 
{

	_userSetSpherical   : 0,
	_userSetCylindrical : 0,
	_userSetAxis        : 0,	
	_backVertexDistance : 0,
	_meridianOnePower   : 0,
	_meridianTwoPower   : 0,
		
	//temp result labels
	pvtLbl   : $('label#pvtLbl'),
	pvtRecLbl: $('label#pvtRecLbl'),
	theoLbl  : $('label#theoLbl'),
	sltRecLbl: $('label#sltRecLbl'),
	output   : $('label#result-ocular-refraction'),
	sltLbl   : $('label#sltLbl'),

	init: function()
	{
		// console.log('Running BVDCalc');
		app.BVDCalc.setErrorPrompt();
		app.BVDCalc.updateResult();
		return;
	},

	nextNearest: function(arg1, arg2)
	{
		var loc1 = arg1 < 0;
		arg1 = Math.abs(arg1);
		var loc2 = Math.ceil(arg1);
		var loc3;
		if ((loc3 = arg1 % arg2) > 0) 
		{
			if (loc3 % arg2 > arg2 / 2) 
			{
				arg1 = arg1 - loc3 + arg2;
			}
			else 
			{
				arg1 = arg1 - loc3;
			}
		}
		if (loc1) 
		{
			arg1 = -arg1;
		}
		return arg1;
	},

	calculateNewResult: function()
	{

		app.BVDCalc._meridianOnePower = Number(app.BVDCalc._userSetSpherical / (1 - 0.001 * app.BVDCalc._backVertexDistance * app.BVDCalc._userSetSpherical));
		app.BVDCalc._meridianTwoPower = Number((app.BVDCalc._userSetSpherical + app.BVDCalc._userSetCylindrical) / (1 - 0.001 * app.BVDCalc._backVertexDistance * (app.BVDCalc._userSetSpherical + app.BVDCalc._userSetCylindrical)));
		
		var _output_s = app.BVDCalc.nextNearest(app.BVDCalc._meridianOnePower, 0.25),
		_output_c     = app.BVDCalc.nextNearest(app.BVDCalc._meridianTwoPower, 0.25) - app.BVDCalc.nextNearest(app.BVDCalc._meridianOnePower, 0.25),
		_output_a     = app.BVDCalc._userSetAxis,
		_output_a     = _output_a != 0 ? _output_a : 180,
		loc1          = _output_s > 0 ? "+" : "",
		loc2          = _output_c > 0 ? "+" : "",
		result        = loc1 + _output_s.toFixed(2) + " / " + loc2 + _output_c.toFixed(2) + " x " + _output_a.toFixed(0);

		// console.log('Recalculated to ' + result);

		$('label#result-ocular-refraction').html(result);

		return;
	},

	updateResult: function()
	{
		// console.log('updating');
		app.BVDCalc._userSetSpherical = Number($('#userSetSpherical-BVD').val());
		app.BVDCalc._userSetCylindrical = Number($('#userSetCylindrical-BVD').val());
		app.BVDCalc._userSetAxis = Number($('#userSetAxis-BVD').val());
		
		app.BVDCalc._backVertexDistance = Number($('#slider-backvertex-value-BVD').attr("data-value"));
			

		// console.log(app.BVDCalc._userSetSpherical, app.BVDCalc._userSetCylindrical, app.BVDCalc._userSetAxis, app.BVDCalc._backVertexDistance);
		app.BVDCalc.calculateNewResult();
		return;
	},

	setErrorPrompt: function()
	{
		// alert('setErrorPrompt');
		return;
	}

}






 
